module.exports = __webpack_public_path__ + "static/media/site-logo.c70b85c6.svg";